import React from "react";
import { Check, ArrowRight } from "lucide-react";

const CHECKOUT = "https://pay.cakto.com.br/h5sjjek?affiliate=5dCccyPE";

const mainList = [
  "Curso completo de TikTok Shop",
  "Edição na prática: perfil dark",
  "Comunidade VIP",
  "Calls semanais com alunos",
  "Suporte prioritário",
];

const bonusList = [
  "Grupo de ferramentas",
  "Grupo de troca de seguidores",
  "Grupo de produtos validados",
  "Você vai aprender a fazer IA ultra-realista",
  "Estratégia pra escalar sua live shop",
  "Estratégia para escalar 10K por mês",
];

const PricingSection = () => {
  return (
    <section className="section" id="preco" style={{
      background: "radial-gradient(600px 300px at 50% 20%, rgba(245,196,0,0.12), transparent 60%), #000",
    }}>
      <div className="container" style={{ maxWidth: 1080 }}>
        <div style={{ textAlign: "center", marginBottom: 40 }}>
          <div className="eyebrow">ACESSO COMPLETO A VSA</div>
          <h2 className="h-title" style={{ marginTop: 14 }}>
            Acesso <span className="yellow">completo</span> + bônus exclusivos
          </h2>
          <p style={{ maxWidth: 700, margin: "20px auto 0", color: "rgba(255,255,255,0.75)", fontSize: 17 }}>
            Tudo que você precisa para começar a vender no TikTok Shop.
          </p>
        </div>

        <div className="price-card">
          <div style={{ display: "grid", gridTemplateColumns: "1fr", gap: 14 }}>
            {mainList.map((item, i) => (
              <div key={i} style={{ display: "flex", alignItems: "center", gap: 14 }}>
                <span className="price-check"><Check size={14} strokeWidth={3} /></span>
                <span style={{ fontSize: 16 }}>{item}</span>
              </div>
            ))}
          </div>

          <div className="price-line" />

          <div style={{ textAlign: "center", marginBottom: 14 }}>
            <span className="yellow" style={{ fontWeight: 800, letterSpacing: 1 }}>Ainda não acabou, você vai receber + 6 bônus extras:</span>
          </div>

          <div style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
            gap: 14,
          }}>
            {bonusList.map((item, i) => (
              <div key={i} style={{ display: "flex", alignItems: "center", gap: 14 }}>
                <span className="price-check"><Check size={14} strokeWidth={3} /></span>
                <span style={{ fontSize: 15 }}>{item}</span>
              </div>
            ))}
          </div>

          <div className="price-line" />

          <div style={{ textAlign: "center" }}>
            <div style={{ color: "rgba(255,255,255,0.55)", textDecoration: "line-through", fontSize: 16 }}>De R$597</div>
            <div style={{ marginTop: 4, color: "rgba(255,255,255,0.85)", fontSize: 16 }}>Por: 12x de</div>
            <div style={{
              fontSize: 68, fontWeight: 900, lineHeight: 1,
              background: "linear-gradient(180deg, #FFE47A, #F5C400 60%, #B88700)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              marginTop: 8,
              letterSpacing: "-1px",
            }}>R$15,57</div>
            <div style={{ marginTop: 6, color: "rgba(255,255,255,0.75)", fontSize: 15 }}>
              ou <strong>R$149,90</strong> à vista
            </div>

            <div style={{ marginTop: 30, display: "flex", justifyContent: "center" }}>
              <a href={CHECKOUT} target="_blank" rel="noreferrer" className="cta-btn" style={{ padding: "6px 6px 6px 28px" }}>
                <span className="pill">QUERO ENTRAR AGORA</span>
                <span className="arrow"><ArrowRight size={20} strokeWidth={2.5} /></span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PricingSection;
